function countObject(object) {
    let count = 0

    for (var k in object) {
        if (object.hasOwnProperty(k)) {
           ++count
        }
    }

    return count
}

function filterObject(object, method) {
    let result = {},
        key

    for (key in object) {
        if (object.hasOwnProperty(key) && method(object[key])) {
            result[key] = object[key]
        }
    }

    return result
}

function filterObjectByKey(object, method) {
    let result = {},
        key

    for (key in object) {
        if (object.hasOwnProperty(key) && method(key)) {
            result[key] = object[key]
        }
    }

    return result
}

function isEmpty(object) {
    return Object.keys(object).length == 0
}

function sliceObject(object, from, to) {
    return Object.keys(object).slice(from, to).reduce((result, key) => {
        result[key] = object[key]

        return result
    }, {})
}

function differenceBetweenObjects(fromObject, toObject){
    const changes = {};

    const buildPath = (path, obj, key) =>
        _.isUndefined(path) ? key : `${path}.${key}`;

    const walk = (fromObject, toObject, path) => {
        for (const key of _.keys(fromObject)) {
            const currentPath = buildPath(path, fromObject, key);
            if (!_.has(toObject, key)) {
                changes[currentPath] = {from: _.get(fromObject, key)};
            }
        }

        for (const [key, to] of _.entries(toObject)) {
            const currentPath = buildPath(path, toObject, key);
            if (!_.has(fromObject, key)) {
                changes[currentPath] = {to};
            } else {
                const from = _.get(fromObject, key);
                if (!_.isEqual(from, to)) {
                    if (_.isObjectLike(to) && _.isObjectLike(from)) {
                        walk(from, to, currentPath);
                    } else {
                        changes[currentPath] = {from, to};
                    }
                }
            }
        }
    };

    walk(fromObject, toObject);

    return changes;
}

export {
    countObject,
    filterObject,
    filterObjectByKey,
    isEmpty,
    sliceObject,
    differenceBetweenObjects,
}